export const baseUrl = 'https://api.coingecko.com/api/v3';